module.exports = __webpack_public_path__ + "static/media/cn.d09f389e.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/cn.svg
// module id = 2067
// module chunks = 0